import React from 'react';
import PropTypes from 'prop-types';
//restClient
import {taxonomyHostClient} from '../../../../../restClient';
//children
import SimpleDropdown from '../../../../common/SimpleDropdown';
//style
import './IETierPicker.css';

const WEEKLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:weekly';
const MONTHLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly';
const ANNUALLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:annually';
const QUARTERLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:quarterly';
const CALENDER_DATE = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:calenderDate';
const SPECIFIC_DAY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly:specificDay';

export default class IETierPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sweepFrequency: {
        frequencyType: {
          name: 'Monthly',
          value: MONTHLY
        },
        frequencyDetails: {},
        frequencyDetailValue: {},
        dates: []
      },
      sweepFrequencyDataDictionary: [],
      noOfDates: 1
    };
    this.defaultPicks = {};
    this.dataDictionaryURI='';
    this.defaultDropdownValue='';
  }

  componentWillMount() {
    this.getTaxanomyUrl();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }
  }

  getTaxanomyUrl = () => {
    this.dataDictionaryURI =this.props.dataDictionaryURI;    
    this.getUpdatedTaxanomy();
  }

  getUpdatedTaxanomy=()=>{    
    this.dataDictionaryURI = this.props.dataDictionaryURI;
    if(this.dataDictionaryURI !== undefined && this.dataDictionaryURI !== '') {
      taxonomyHostClient(this.dataDictionaryURI)
      .then(({data}) => {
        if(data.responseData !== undefined && data.responseData.classificationNodes !== undefined){
        this.setState({sweepFrequencyDataDictionary: data.responseData.classificationNodes});
        this.pickDefaultsFromDataDictionary(data.responseData.classificationNodes);
        }
      });
    }else if(this.dataDictionary !== undefined) {
      this.setState({sweepFrequencyDataDictionary: this.props.dataDictionary});
      this.pickDefaultsFromDataDictionary([...this.props.dataDictionary]);
    }else {
      throw new Error('Either Data Dictionary (dataDictionary) or Data Dictionary URI (dataDictionaryURI) is required');
    }

    if(this.props._value !== undefined) {
      var noOfDates = 1;
      if(this.props._value.dates) {
        noOfDates = this.props._value.dates.length === 0 ? 1 : this.props._value.dates.length;
      }
      this.setState({
        sweepFrequency: this.props._value,
        noOfDates
      });
    }
  }
  
  pickDefaultsFromDataDictionary = (dataDictionary) => {
    dataDictionary.forEach(dd => {
      this.defaultPicks[dd.id] = dd.associations ? {name: dd.associations[0].name, value: dd.associations[0].id} : undefined;
      if(dd.associations) {
        dd.associations.forEach(subDd => {
          this.defaultPicks[subDd.id] = subDd.associations ? {name: subDd.associations[0].name, value: subDd.associations[0].id} : undefined;
        });
      }
    });

  }

  setDefaultSelections = (fieldName, sweepFrequency) => {
    if(fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === WEEKLY) {
      sweepFrequency.frequencyDetails = {name: '',value: ''};
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    }else if(fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === QUARTERLY) {
      sweepFrequency.frequencyDetails = {name: 'First Day',value: 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:quarterly:firstDay'};
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    }else if(fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === MONTHLY) {
      sweepFrequency.frequencyDetails = {name: '',value: ''};
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    }else if(fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === ANNUALLY) {
      sweepFrequency.frequencyDetails = undefined;
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = '';
      sweepFrequency.dates = undefined;
    }else if(fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === CALENDER_DATE) {
      sweepFrequency.frequencyDetails = undefined;
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = [];
    }else if(fieldName === 'frequencyDetails' && sweepFrequency.frequencyType.value === MONTHLY && sweepFrequency.frequencyDetails.value === SPECIFIC_DAY) {
      sweepFrequency.frequencyDetailValue = this.defaultPicks[SPECIFIC_DAY];
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    }
    return sweepFrequency;
  }

  setSweepFrequencyDropDownSubValue = (event) => {
    var fieldName = event.target.name;
    var sweepFrequency = {
      ...this.state.sweepFrequency,
      [event.target.name]: {
        name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
        value: event.target.value
      }
    };
    sweepFrequency = this.setDefaultSelections(fieldName, {...sweepFrequency});

    this.setState({sweepFrequency}, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
  }

  setAnnualDateValue = (event) => {
    var sweepFrequency = {
      ...this.state.sweepFrequency,
      [event.target.name]: event.target.value
    };
    this.setState({sweepFrequency}, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
  }

  setCalenderValues = (index, event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      var dates = [...this.state.sweepFrequency.dates];
      if(dates) {
        dates[index] = event.target.value;
      }
      this.setState({sweepFrequency: {...this.state.sweepFrequency, dates}}, () => {
        this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
      });
    }
  }

  validateDate = (event) => {
    var first = event.target.value.slice(0,2);
    var second = event.target.value.slice(2,4);
    if(event.target.value.length === 0){
      this.setState({validationMgs : false})
    }
    if(event.target.value.length < 4 && event.target.value.length !== 0){
      return  this.setState({validationMgs : true})
    }
    if (event.target.value.length === 4) {
      if (first > 31 || second > 12) {
          this.setState({validationMgs : true})
      }
    }
    if(first <= 31 && second <= 12 && second !=='' && first !==''){
      this.setState({validationMgs : false})
    }else if(second !=='' && first !=='') {
        this.setState({validationMgs : true})
    }
    return false;
  }


  getSubFieldOptions = (sweepType, subType) => {
    if(subType) {
      return this.state.sweepFrequencyDataDictionary
      .find(sfType => sfType.id === sweepType)
      .associations
      .find(_subType => _subType.id === subType)
      .associations;
    }else {
      return this.state.sweepFrequencyDataDictionary
      .find(sfType => sfType.id === sweepType)
      .associations;
    }
  }

  onSweepDateAddition = (e) => {
    e.preventDefault();
    this.setState(prevState => {
      return {
        noOfDates: prevState.noOfDates+1
      }
    });
  }

  onSweepDateDeletion = (index) => {
    var dates = [...this.state.sweepFrequency.dates];
    dates.splice(index, 1);
    this.setState(prevState => {
      return {
        sweepFrequency: {...prevState.sweepFrequency, dates},
        noOfDates: prevState.noOfDates-1
      }
    }, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
  }

  render() {
    var datesJsx = [];
    for(var i=1; i<this.state.noOfDates; i++) {
      datesJsx.push(
        <div className="sweep-date-section-wrapper clearfix gdocs-mtop-15 gdocs-mbottom-15" key={i}>
        <label className="sweep-date-section__label">{`${this.props.subLabels[2]} ${i+1}`}</label>
        <div className="sweep-date-section__input-section">
        <input type="text"
        name={`dates${i}`}
        disabled={this.props.disabled}
        placeholder="DD MM"
        maxLength={this.props.maxChars !== undefined ? this.props.maxChars[0] : '4' }
        value={this.state.sweepFrequency.dates !== undefined && this.state.sweepFrequency.dates.length > 0 ? this.state.sweepFrequency.dates[i]: ''}
        onChange={this.setCalenderValues.bind(this, i)} />
        </div>
        <i className="icon icon-bin" onClick={this.onSweepDateDeletion.bind(this, i)}></i>
        </div>
      );
    }
    if(this.props.lang.currentLang.lang === "English"){
      this.defaultDropdownValue = "Please Select"
    } else if (this.props.lang.currentLang.lang === "Spanish"){
      this.defaultDropdownValue = "Seleccione"
    }else if (this.props.lang.currentLang.lang === "Bahasa"){
      this.defaultDropdownValue = "Harap pilih"
    }

    return (this.state.sweepFrequencyDataDictionary.length > 0 ? (
      <div className="sweep-frequency-picker clearfix gdocs-mtop-15">
      <label className="sweep-frequency-picker__label">{this.props.boxLabel || "Sweep frequency"}</label>
      <div className="sweep-frequency-picker__input-section">
      <SimpleDropdown name='frequencyType'
      options={this.state.sweepFrequencyDataDictionary}
      optionTextSelector="name"
      disabled={this.props.disabled}
      showPleaseSelectOption={false}
      value={this.state.sweepFrequency['frequencyType'].value}
      width="198px"
      _onChange={this.setSweepFrequencyDropDownSubValue} />
      </div>
      <div className="clearBth"></div>
      {
        this.state.sweepFrequency.frequencyType.value === WEEKLY ? (
          <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--weekly gdocs-mtop-15">
          <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Settlement Date"}:</label>
          <SimpleDropdown name='frequencyDetails'
          options={this.getSubFieldOptions(WEEKLY)}
          optionTextSelector="name"
          disabled={this.props.disabled}
          defaultValue= {this.defaultDropdownValue}
          showPleaseSelectOption={true}
          value={this.state.sweepFrequency['frequencyDetails'].value}
          width="198px"
          _onChange={this.setSweepFrequencyDropDownSubValue} />
          </div>
        ) : ''
      }
      {
        this.state.sweepFrequency.frequencyType.value === QUARTERLY ? (
          <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--weekly gdocs-mtop-15">
          <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Settlement date"}:</label>
          <SimpleDropdown name='frequencyDetails'
          options={this.getSubFieldOptions(QUARTERLY)}
          optionTextSelector="name"
          showPleaseSelectOption={false}
          defaultValue= {this.defaultDropdownValue}
          disabled={this.props.disabled}
          value={ this.state.sweepFrequency['frequencyDetails'] !== undefined ? this.state.sweepFrequency['frequencyDetails'].value : ''}
          width="198px"
          _onChange={this.setSweepFrequencyDropDownSubValue} />
          </div>
        ) : ''
      }
      {
        this.state.sweepFrequency.frequencyType.value === MONTHLY ? (
          <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--monthly gdocs-mtop-15">
          <label className="sweep-frequency-picker__input-label gls-sweep-freq-picker__input-align gdoc-margin-rt">{this.props.subLabels[0] || "Settlement Date"}</label>
          <div className="gls-sweep-freq-picker__input-align">
          <SimpleDropdown name='frequencyDetails'
          options={this.getSubFieldOptions(MONTHLY)}
          optionTextSelector="name"
          showPleaseSelectOption={true}
          defaultValue= {this.defaultDropdownValue}
          disabled={this.props.disabled}
          value={this.state.sweepFrequency['frequencyDetails'].value}
          width="215px"
          _onChange={this.setSweepFrequencyDropDownSubValue} />
          </div>
          <div className="clearBth"></div>
          {
            this.state.sweepFrequency.frequencyDetails.value === SPECIFIC_DAY ? (
              <div className="gdocs-mtop-15">
              <label className="sweep-frequency-picker__input-label choose-day gls-sweep-spec-day-label-align">{this.props.subLabels[1] || "Choose day"}</label>
              <div className="gls-sweep-freq-picker__input-align">
              <SimpleDropdown bsClass='specific-day-values inline-grid'
              name='frequencyDetailValue'
              options={this.getSubFieldOptions(MONTHLY, SPECIFIC_DAY)}
              optionTextSelector="name"
              disabled={this.props.disabled}
              showPleaseSelectOption={false}
              width="98px"
              value={this.state.sweepFrequency['frequencyDetailValue'].value}
              _onChange={this.setSweepFrequencyDropDownSubValue} />
              </div>
              <div className="clearBth"></div>
              </div>
            ) : ''
          }
          </div>
        ) : ''
      }
      {
        this.state.sweepFrequency.frequencyType.value === ANNUALLY ? (
          <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--annually gdocs-mtop-15">
          <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Settlement date"}</label>
          <input type="text"
          name="annualDate"
          disabled={this.props.disabled}
          placeholder="DD MM"
          onBlur={this.validateDate}
          maxLength={this.props.maxChars !== undefined ? this.props.maxChars[0] : '4' }
          value={this.state.sweepFrequency.annualDate}
          onChange={this.setAnnualDateValue} />
          {this.state.validationMgs ? <span className="input-error-msg-section">
          <span className="icon icon-circle-delete-solid"></span>{this.props.mandatoryMessage || 'This is not a valid time entry'}</span> :''}

          </div>
        ) : ''
      }
      {
        this.state.sweepFrequency.frequencyType.value === CALENDER_DATE ? (
          <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--calender">
          <div className="sweep-date-section">
          <div className="sweep-date-section-wrapper clearfix">
          <label className="sweep-date-section__label">{this.props.subLabels[0] || "Settlement date"} 1</label>
          <div className="sweep-date-section__input-section">
          <input type="text"
          name="dates0"
          disabled={this.props.disabled}
          placeholder="DD MM"
          onBlur={this.validateDate}
          maxLength={this.props.maxChars !== undefined ? this.props.maxChars[0] : '4' }
          value={this.state.sweepFrequency.dates[0] ? this.state.sweepFrequency.dates[0]: ''}
          onChange={this.setCalenderValues.bind(this, 0)} />
          {this.state.validationMgs ? <span className="input-error-msg-section">
          <span className="icon icon-circle-delete-solid"></span>{this.props.mandatoryMessage || 'This is not a valid time entry'}</span> :''}
          </div>
          </div>
          {datesJsx}
          <button className="gdocs-btn-default" onClick={this.onSweepDateAddition}><i className="icon icon-add"></i> {this.props.subLabels[0] || "Add another"}</button>
          </div>
          </div>
        ) : ''
      }
      </div>
    ) : '');
  }
}

IETierPicker.propTypes = {
  name: PropTypes.string.isRequired,
  subLabels: PropTypes.array.isRequired,
  subNames: PropTypes.array.isRequired,
  setInputvalue: PropTypes.func.isRequired,
  dataDictionaryURI: PropTypes.string,
  dataDictionary: PropTypes.object,
  _value: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/IETierPicker/IETierPicker.js